import { render } from "./resumenComponent.vue?vue&type=template&id=37ec3b3f"
import script from "./resumenComponent.vue?vue&type=script&lang=js"
export * from "./resumenComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__